/**
 * WhatsApp sipariş linkini seçili varyant ve adetle günceller.
 * Şablon tema ayarından gelir: {urun}, {varyant}, {adet} yer tutucuları.
 */
const build = (link) => {
  const form = document.getElementById(link.dataset.form);
  if (!form) return;
  const qtyInput = document.querySelector(`input[name="quantity"][form="${link.dataset.form}"]`) || form.querySelector('[name="quantity"]');
  const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
  const variantTitle = link.dataset.variant || '';
  const text = (link.dataset.template || '')
    .replaceAll('{urun}', link.dataset.product || '')
    .replaceAll('{varyant}', variantTitle && variantTitle !== 'Default Title' ? `(${variantTitle})` : '')
    .replaceAll('{adet}', String(qty))
    .replace(/\s{2,}/g, ' ')
    .trim();
  link.href = `https://wa.me/${link.dataset.number}?text=${encodeURIComponent(text)}`;
};

const init = (link) => {
  if (link.dataset.pgWaBound) return;
  link.dataset.pgWaBound = 'true';
  const scope = link.closest('.shopify-section') || document;
  scope.addEventListener('variant:updated', (e) => {
    link.dataset.variant = e.detail?.variant?.title || '';
    build(link);
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches?.(`input[name="quantity"][form="${link.dataset.form}"]`)) build(link);
  });
  // Tıklama anında son değerlerle yeniden oluştur (adet +/- butonları change yaymasa bile)
  link.addEventListener('pointerdown', () => build(link));
  link.addEventListener('keydown', (e) => { if (e.key === 'Enter') build(link); });
};

document.querySelectorAll('[data-pg-whatsapp-order]').forEach(init);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-pg-whatsapp-order]').forEach(init));
